import {connect} from 'react-redux';
import {fetchDiagnosesForDropdown} from 'reducers/diagnoses/diagnosesActions';
import DiagnosisDropdown from './DiagnosisDropdown';

const mapStateToProps = (state) => ({
    ...state.diagnosis,
});

const mapDispatchToProps = {
    onSearch: fetchDiagnosesForDropdown,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiagnosisDropdown);



// WEBPACK FOOTER //
// ./src/components/controls/DiagnosisDropdownContainer.js